var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "titleForm",
              attrs: {
                model: _vm.titleForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeTitleStyle("show")
                        },
                      },
                      model: {
                        value: _vm.titleForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.titleForm, "show", $$v)
                        },
                        expression: "titleForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.titleForm.show,
                      expression: "titleForm.show",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.text_fontsize"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("fontSize")
                            },
                          },
                          model: {
                            value: _vm.titleForm.fontSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "fontSize", $$v)
                            },
                            expression: "titleForm.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeTitleStyle("color")
                          },
                        },
                        model: {
                          value: _vm.titleForm.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.titleForm, "color", $$v)
                          },
                          expression: "titleForm.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_h_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("hPosition")
                            },
                          },
                          model: {
                            value: _vm.titleForm.hPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "hPosition", $$v)
                            },
                            expression: "titleForm.hPosition",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_left"))),
                          ]),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "center" } },
                            [_vm._v(_vm._s(_vm.$t("chart.text_pos_center")))]
                          ),
                          _c("el-radio-button", { attrs: { label: "right" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_right"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_v_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("vPosition")
                            },
                          },
                          model: {
                            value: _vm.titleForm.vPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "vPosition", $$v)
                            },
                            expression: "titleForm.vPosition",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "top" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_top"))),
                          ]),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "center" } },
                            [_vm._v(_vm._s(_vm.$t("chart.text_pos_center")))]
                          ),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "bottom" } },
                            [_vm._v(_vm._s(_vm.$t("chart.text_pos_bottom")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_style") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("isItalic")
                            },
                          },
                          model: {
                            value: _vm.titleForm.isItalic,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "isItalic", $$v)
                            },
                            expression: "titleForm.isItalic",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.italic")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("isBolder")
                            },
                          },
                          model: {
                            value: _vm.titleForm.isBolder,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "isBolder", $$v)
                            },
                            expression: "titleForm.isBolder",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.bolder")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }